import React from 'react';
import PropTypes from 'prop-types';

function TagSection({ tags }) {
  if (!tags?.tags || tags.tags.length === 0) return null;

  return (
    <ul className="flex flex-wrap list-none my-[1vw] mx-[-5px] p-0" data-cy="order-details-tags">
      {tags.tags.map(item => (
        <li 
          key={item} 
          data-cy={`order-details-tag-${item}`}
          className="flex items-center justify-center h-[24px] mx-[5px] px-[20px] rounded-full text-[calc(6px+0.4vw)] bg-[#658ec6] text-white"
        >
          {item}
        </li>
      ))}
    </ul>
  );
}

TagSection.propTypes = {
  tags: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};

export default TagSection;
